import { createBrowserRouter, Navigate } from 'react-router-dom';

import { ApprovedClientApontamentosPage } from '@/pages/ApprovedClientApontamentosPage';
import { ApprovedClientDetailPage } from '@/pages/ApprovedClientDetailPage';
import { ApprovedPage } from '@/pages/ApprovedPage';
import { BlocklistPage } from '@/pages/BlocklistPage';
import { ClientDetailPage } from '@/pages/ClientDetailPage';
import { CreatePasswordPage } from '@/pages/CreatePasswordPage';
import { DimensaPage } from '@/pages/DimensaPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { LoginPage } from '@/pages/LoginPage';
import { LogsPage } from '@/pages/LogsPage';
import { ModulesPage } from '@/pages/ModulesPage';
import { OnboardingDashboardPage } from '@/pages/OnboardingDashboardPage';
import { PreAnalysisPage } from '@/pages/PreAnalysisPage';
import { RejectedClientApontamentosPage } from '@/pages/RejectedClientApontamentosPage';
import { RejectedClientDetailPage } from '@/pages/RejectedClientDetailPage';
import { RejectedPage } from '@/pages/RejectedPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { VerifyCodePage } from '@/pages/VerifyCodePage';
import { APP_ROUTES } from '@shared/constants/routes.constants';

import { GuestRoute, PrivateRoute } from './guards';

/**
 * Application router configuration
 */
export const router = createBrowserRouter([
  // ==========================================
  // PUBLIC ROUTES (Guest Only - Not Authenticated)
  // ==========================================
  {
    path: APP_ROUTES.LOGIN,
    element: (
      <GuestRoute>
        <LoginPage />
      </GuestRoute>
    ),
  },
  {
    path: APP_ROUTES.FORGOT_PASSWORD as string,
    element: (
      <GuestRoute>
        <ForgotPasswordPage />
      </GuestRoute>
    ),
  },
  {
    path: APP_ROUTES.VERIFY_CODE as string,
    element: (
      <GuestRoute>
        <VerifyCodePage />
      </GuestRoute>
    ),
  },
  {
    path: APP_ROUTES.RESET_PASSWORD as string,
    element: (
      <GuestRoute>
        <ResetPasswordPage
          title="Redefinir senha"
          subtitle="Escolha uma nova senha para esta conta de usuário."
        />
      </GuestRoute>
    ),
  },

  // ==========================================
  // PRIVATE ROUTES (Authenticated Only)
  // ==========================================
  {
    path: APP_ROUTES.CREATE_PASSWORD,
    element: (
      <PrivateRoute>
        <CreatePasswordPage />
      </PrivateRoute>
    ),
  },
  {
    path: APP_ROUTES.MODULES,
    element: (
      <PrivateRoute>
        <ModulesPage />
      </PrivateRoute>
    ),
  },
  {
    path: APP_ROUTES.DASHBOARD,
    element: (
      <PrivateRoute>
        <div>Dashboard (TODO)</div>
      </PrivateRoute>
    ),
  },
  {
    path: APP_ROUTES.ONBOARDING,
    element: (
      <PrivateRoute>
        <OnboardingDashboardPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/pre-analysis',
    element: (
      <PrivateRoute>
        <PreAnalysisPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/approved',
    element: (
      <PrivateRoute>
        <ApprovedPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/approved/client/:clientId',
    element: (
      <PrivateRoute>
        <ApprovedClientDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/approved/client/:clientId/apontamentos',
    element: (
      <PrivateRoute>
        <ApprovedClientApontamentosPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/rejected',
    element: (
      <PrivateRoute>
        <RejectedPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/rejected/client/:clientId',
    element: (
      <PrivateRoute>
        <RejectedClientDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/rejected/client/:clientId/apontamentos',
    element: (
      <PrivateRoute>
        <RejectedClientApontamentosPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/blacklist',
    element: (
      <PrivateRoute>
        <BlocklistPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/client/:clientId',
    element: (
      <PrivateRoute>
        <ClientDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/onboarding/dimensa/:clientId',
    element: (
      <PrivateRoute>
        <DimensaPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/logs',
    element: (
      <PrivateRoute>
        <LogsPage />
      </PrivateRoute>
    ),
  },
  {
    path: APP_ROUTES.ACCESS_MANAGEMENT,
    element: (
      <PrivateRoute>
        <div>Access Management (TODO)</div>
      </PrivateRoute>
    ),
  },

  // ==========================================
  // REDIRECTS
  // ==========================================
  {
    path: '/',
    element: <Navigate to={APP_ROUTES.LOGIN} replace />,
  },
  {
    path: '*',
    element: <Navigate to={APP_ROUTES.LOGIN} replace />,
  },
]);
